import {
  useCallback,
  useMemo
} from 'react';
import {
  CustomerOrderActionsWidgetDocument,
  Customer_FulfillmentStatusWidgetDocument,
  SummaryInformationWidgetDocument,
  useCloseOrderAsCustomerMutation,
  useCustomerOrderActionsWidgetQuery
} from 'generated/graphql';



export interface IData {
  canCloseOrder: boolean;
  canInitiateReturnAuthorization: boolean;
}

export function useQuery(orderId: string) {
  const tuple = useCustomerOrderActionsWidgetQuery({
    variables: {
      orderId
    }
  });

  return useMemo(
    () => {
      const data: IData = {
        canCloseOrder: tuple.data?.canCloseOrder ?? false,
        canInitiateReturnAuthorization: tuple.data?.canInitiateReturnAuthorization ?? false
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useCloseOrderAsCustomer(orderId: string) {
  const [fnMutate, tuple] = useCloseOrderAsCustomerMutation({
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: CustomerOrderActionsWidgetDocument,
        variables: { orderId }
      },
      {
        query: Customer_FulfillmentStatusWidgetDocument,
        variables: { orderId }
      },
      {
        query: SummaryInformationWidgetDocument,
        variables: { orderId }
      }
    ]
  });

  const fnWrappedMutate = useCallback(
    () => {
      fnMutate({
        variables: {
          orderId
        }
      });
    },
    [
      fnMutate,
      orderId
    ]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
